export const TYPES = {
  app: 'app',
  integration: 'integration',
  app_integration: 'app_integration',
}

export const APPS = {
  ats: 'ats',
  ats_careers_page: 'ats_careers_page',
  payroll_bundle: 'payroll_bundle',
  expenses: 'expenses',
  expenses_v2: 'expenses_v2',
  time_tracking: 'time_tracking',
  performance_v2: 'performance_v2',
  surveys: 'surveys',
  trainings: 'trainings_custom_table',
  competencies_custom_table: 'competencies_custom_table',
  growth_plans: 'growth_plans_custom_table',
  shift_management: 'shift_management',
  document_templates: 'document_templates',
  employee_onboarding: 'employee_onboarding',
  enps: 'enps',
  competencies: 'competencies',
  complaints: 'complaints',
  join: 'join',
  desky: 'desky',
  linkedin_limited_listings: 'linkedin_limited_listings',
  finance: 'finance',
  ats_whatsapp: 'ats_whatsapp',
  employee_chat_on_whatsapp: 'employee_chat_on_whatsapp',
  ats_idealdisc: 'ats_ideal_disc_integration',
}
